import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-secondary text-white pt-12 pb-8">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img 
                src="https://storage.googleapis.com/msgsndr/RMxB1SgTctXFwLszDoIk/media/6843524231a75e17ffc330fb.png" 
                alt="Snap Launch Studio" 
                className="h-16"
              />
            </div>
            <p className="text-neutral">
              Modern, mobile-friendly websites for small businesses — launched fast and done right.
            </p>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-neutral hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-neutral hover:text-white transition-colors">About</Link></li>
              <li><Link to="/services" className="text-neutral hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/crm-system" className="text-neutral hover:text-white transition-colors">CRM System</Link></li>
              <li><Link to="/faq" className="text-neutral hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/contact" className="text-neutral hover:text-white transition-colors">Contact</Link></li>
              <li><Link to="/privacy" className="text-neutral hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-neutral hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="pt-8 border-t border-secondary-light/20 text-sm text-neutral">
          <div className="flex flex-col md:flex-row justify-between gap-4">
            <p>&copy; {currentYear} Snap Launch Studio. All rights reserved.</p>
            <div className="flex gap-6">
              <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
